import { render, staticRenderFns } from "./SuspectReportModal.vue?vue&type=template&id=8391f7a6&scoped=true"
import script from "./SuspectReportModal.vue?vue&type=script&lang=js"
export * from "./SuspectReportModal.vue?vue&type=script&lang=js"
import style0 from "./SuspectReportModal.vue?vue&type=style&index=0&id=8391f7a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8391f7a6",
  null
  
)

export default component.exports